/**
 * Shared InfoTooltip Component
 * Bundled Tippy.js — works offline (no CDN).
 */

import React, { useRef, useEffect } from 'react';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

const InfoTooltip = ({ children, content }) => {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!triggerRef.current) return;

    try {
      if (triggerRef.current._tippy) {
        triggerRef.current._tippy.destroy();
      }

      const instance = tippy(triggerRef.current, {
        content:
          typeof content === 'string' && content.trim().length > 0
            ? content
            : 'Help text coming soon.',
        allowHTML: false,
        maxWidth: 420,
        theme: 'light',
        placement: 'right',
        interactive: true,
        delay: [80, 80],
        appendTo: () => document.body,
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
          ],
        },
      });

      return () => {
        instance.destroy();
      };
    } catch (error) {
      console.error('InfoTooltip initialization error:', error);
    }
  }, [content]);

  return (
    <span ref={triggerRef} className="inline-flex items-center cursor-help">
      {children}
      <span
        className="ml-1 inline-block text-blue-600 text-xs"
        style={{
          width: 16,
          height: 16,
          lineHeight: '16px',
          textAlign: 'center',
          borderRadius: 8,
          border: '1px solid #2563eb',
          fontWeight: 700,
        }}
      >
        ?
      </span>
    </span>
  );
};

export default InfoTooltip;
